import React, { useRef, useEffect } from 'react';
import { Paper, Box, Typography, Button } from '@mui/material';
import { Task } from '../../../types';

interface TaskFormWrapperProps {
  task: Task;
  children: React.ReactNode;
  onSubmit: (formData: any) => void;
}

export const TaskFormWrapper: React.FC<TaskFormWrapperProps> = ({
  task,
  children,
  onSubmit
}) => {
  const formRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({});
  };

  return (
    <Paper ref={formRef} sx={{ mt: 3, p: 3 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Complete Task: {task.title}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {children}
          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2, 
            justifyContent: { sm: 'flex-end' }, 
            mt: 2 
          }}>
            <Button 
              type="submit" 
              variant="contained"
              fullWidth
            >
              Complete Task
            </Button>
          </Box>
        </Box>
      </form>
    </Paper>
  );
};